import { BasicCitationStyle } from './basic-citation-style';

export const DEFAULT_CITATION_STYLES: {
  NONE: BasicCitationStyle;
} = {
  NONE: {
    id: undefined,
    description: 'None',
  },
};

export const ALL_DEFAULT_CITATION_STYLES = [DEFAULT_CITATION_STYLES.NONE];
